// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-content {
  --background: var(--main-background);
}

h2, h3, h4, h5 {
  font-size: 20px;
  line-height: 116%;
  letter-spacing: 0.02em;
  vertical-align: middle;
  text-transform: uppercase;
  margin-top: 20px;
  margin-bottom: 10px;
}
@media (max-width: 992px) {
  h2, h3, h4, h5 {
    font-size: 16px;
  }
}

h4 {
  font-size: 18px;
}
@media (max-width: 992px) {
  h4 {
    font-size: 15px;
  }
}

p {
  font-size: 16px;
  line-height: 120%;
  vertical-align: middle;
}
@media (max-width: 992px) {
  p {
    font-size: 14px;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/pages/impressum/impressum.page.scss","webpack://./src/theme/mixins.scss"],"names":[],"mappings":"AAEA;EACE,oCAAA;AADF;;AAIA;EACC,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,sBAAA;EACA,yBAAA;EACA,gBAAA;EACA,mBAAA;AADD;ACLE;EDDF;IAUI,eAAA;EAAF;AACF;;AAGA;EACE,eAAA;AAAF;ACdE;EDaF;IAGI,eAAA;EAEF;AACF;;AACA;EACC,eAAA;EACA,iBAAA;EACA,sBAAA;AAED;ACzBE;EDoBF;IAMI,eAAA;EAGF;AACF","sourcesContent":["@import '../../../theme/mixins';\n\nion-content {\n  --background: var(--main-background);\n}\n\nh2, h3, h4, h5 {\n\tfont-size: 20px;\n\tline-height: 116%;\n\tletter-spacing: 0.02em;\n\tvertical-align: middle;\n\ttext-transform: uppercase;\n\tmargin-top: 20px;\n\tmargin-bottom: 10px;\n\n  @include mobile {\n    font-size: 16px;\n  }\n}\n\nh4 {\n  font-size: 18px;\n  @include mobile {\n    font-size: 15px;\n  }\n}\n\np {\n\tfont-size: 16px;\n\tline-height: 120%;\n\tvertical-align: middle;\n\n  @include mobile {\n    font-size: 14px;\n  }\n}\n","@mixin desktop {\n  @media (min-width: 991px) {\n    @content;\n  }\n}\n\n@mixin mobile {\n  @media (max-width: 992px) {\n    @content\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
